import { sumValues, throwTranslatableError } from '@/core';
import { updateTripsRequest } from '../../requests';
import deepCopy from 'deepcopy';
import createTripOrder from './addOrdersToTrip/createTripOrder';
import rdbClient from 'rdb-client';

export default async function moveOrderToDifferentTrip({ commit }, { subOrder, originalTrip, newTrip, despatchOption, deliveryOption, etd, eta, customDespatchParty, customDeliveryParty }) {
	if (!subOrder || !newTrip) {
		throw new Error('failedToAddOrderToTrip');
	}

	let tripCopy = deepCopy(originalTrip);
	let originalTripClone = deepCopy(originalTrip);

	if (originalTrip.orders) {
		let orderIndex = originalTrip.orders.findIndex(x => x.id === subOrder.id);
		originalTrip.orders.splice(orderIndex, 1);
		tripCopy.volume = sumValues(originalTrip.orders, 'volume');
		tripCopy.grossWeight = sumValues(originalTrip.orders, 'grossWeight');
		tripCopy.loadingMeters = sumValues(originalTrip.orders, 'loadingMeters');
	}

	let maxLoadingSeqNo = newTrip.orders ? newTrip.orders.reduce((p,c) => ((c.loadingSeqNo && c.loadingSeqNo > p.loadingSeqNo) ? c : p), 0) : 0;
	if (!maxLoadingSeqNo) maxLoadingSeqNo = 0;
	let newOrder = createTripOrder(subOrder, newTrip, etd, eta, despatchOption, deliveryOption, customDespatchParty, customDeliveryParty, maxLoadingSeqNo++);

	let subOrderUpdates = [];
	subOrderUpdates.push({
		updatedOrder: newOrder
	});

	let newTripCopy = deepCopy(newTrip);
	let newTripClone = deepCopy(newTrip);
	if (!newTrip.orders) newTrip.orders = [];
	newTrip.orders.push(newOrder);

	if (newTrip.orders) {
		newTripCopy.volume = sumValues(newTrip.orders, 'volume');
		newTripCopy.grossWeight = sumValues(newTrip.orders, 'grossWeight');
		newTripCopy.loadingMeters = sumValues(newTrip.orders, 'loadingMeters');
	}

	try {
		let originalData = [ originalTripClone, newTripClone ];
		let updatedData = [ tripCopy, newTripCopy ];
		let patch = rdbClient.createPatch(originalData, updatedData);

		let response = await updateTripsRequest({ ids: [tripCopy.id, newTripCopy.id], patch, subOrderUpdates });
		commit('updateTrips', response);
	} catch (e) {
		console.log(e);
		throwTranslatableError(e, 'failedToAddOrderToTrip');
	}
}